
const isFirmNameValid = firmName => firmName.trim().length > 0;
const isAddressValid = address => address.trim().length > 0;
const isSortCodeValid = sortCode =>  new RegExp("^([0-9][0-9][0-9][0-9][0-9][0-9]|[0-9][0-9]-[0-9][0-9]-[0-9][0-9])$").test(sortCode);
const isPostcodeValid = postcode => new RegExp(/^((([A-PR-UWYZ][0-9])|([A-PR-UWYZ][0-9][0-9])|([A-PR-UWYZ][A-HK-Y][0-9])|([A-PR-UWYZ][A-HK-Y][0-9][0-9])|([A-PR-UWYZ][0-9][A-HJKSTUW])|([A-PR-UWYZ][A-HK-Y][0-9][ABEHMNPRVWXY]))\s?([0-9][ABD-HJLNP-UW-Z]{2})|(GIR)\s?(0AA))$/i).test(postcode);
const isAccountNumberValid = accountNumber => new RegExp("^([0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9])$").test(accountNumber);
const emailRegEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const isEmailAddressValid = email => new RegExp(emailRegEx).test(email);

const referralFormValidationHelper = {
    isFirmNameValid,
    isAddressValid,
    isSortCodeValid,
    isPostcodeValid,
    isAccountNumberValid,
    isEmailAddressValid
};

export default referralFormValidationHelper;
